<template>
  <div id="home-page" class="content">
    <div class="home_left">
      <div class="home_left_text">
        <img src="/assets/images/home_thumbs.png" usemap="#thumbs" style="margin-bottom:5px;">

        <br/>

        <map name="thumbs">
          <area shape="rect" coords="0,0,136,133" href="/menu/burgers">
          <area shape="rect" coords="136,0,256,133" href="/menu/shakes">
          <area shape="rect" coords="256,0,411,133" href="/menu/salads">
        </map>

        <a href="/menu/burgers">
          <img src="/assets/images/lefttop_burgers.png" />
        </a>&nbsp;

        <a href="/menu/sides">
          <img src="/assets/images/lefttop_sides.png" />
        </a>&nbsp;

        <a href="/menu/salads">
          <img src="/assets/images/lefttop_salads.png" />
        </a>&nbsp;

        <a href="/menu/shakes">
          <img src="/assets/images/lefttop_shakes.png" />
        </a>&nbsp;

        <a href="/menu/sandwiches">
          <img src="/assets/images/lefttop_sandwiches.png" />
        </a>&nbsp;

        <br clear="all">

        <br/>

        <div class="left" style="width:410px;">
          <p style="margin-bottom:104px;">
            Jeffrey&#8217;s Hamburgers are the Bay Area&#8217;s best.
            Our burgers are hand made and ground fresh daily from Certified Angus Beef.
            Soups are homemade and salads are the freshest California has to offer.
            Jeffrey&#8217;s - A page from the Golden Era of diners and soda fountains.
            <a href="/menu">Click here</a> to check out our complete menu.
          </p>

          <a
            class="togo-menu-button"
            href="/assets/images/jeffreys_hamburgers_togo.pdf"
            alt="Jeffrey's Hamburgers to go menu"
            target="jeffreys_togo_menu"
          >
            Download Our Takeout Menu
          </a>
        </div>

        <br clear="all">

        <div class="left" style="margin:25px 0 10px 4px; position:relative;">
          <a href="https://jeffreyshamburgers.alohaorderonline.com/">
            <img src="/assets/images/home_orderOnline.png" />
          </a>
        </div>

        <br clear="all">
      </div>
    </div>

    <div class="home_right">
      <div class="home_right_text">
        &#8220;BAY AREA’S BURGER&#8221;
      </div>

      <div class="burgerlink">
        <a href="/menu/burgers">
          <img src="/assets/images/spacer.gif" height="440" width="450" />
        </a>
      </div>

      <div class="mapicon">
        <a href="/locations">
          <img src="/assets/images/map_icon_pluslocations.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>
